import { render, staticRenderFns } from "./partners.vue?vue&type=template&id=a1672380&scoped=true"
import script from "./partners.vue?vue&type=script&lang=js"
export * from "./partners.vue?vue&type=script&lang=js"
import style0 from "./partners.vue?vue&type=style&index=0&id=a1672380&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1672380",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1672380')) {
      api.createRecord('a1672380', component.options)
    } else {
      api.reload('a1672380', component.options)
    }
    module.hot.accept("./partners.vue?vue&type=template&id=a1672380&scoped=true", function () {
      api.rerender('a1672380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cont/about/partners.vue"
export default component.exports